module.exports = __webpack_public_path__ + "img/TVOCppb.24ee0ef7.png";